import { createStore } from 'redux';
import rootReducer from '../reducers/rootReducer';

// combine all states
const initState = {};

const store = createStore(
    rootReducer,
    initState
);

export default store;


// WEBPACK FOOTER //
// ./sources/js/store/store.js